<template>
  <b-card no-body class="mt-n2">
    <b-row class="mx-1 mt-2 mb-1">
      <b-card
        v-if="hasTrafficSelection"
        class="header-card"
      >
        <h4 class="mb-1">Traffic Details</h4>
        <div class="details-row d-flex flex-row mt-2">
          <span>
            <b-icon :style="{ color: iconColors.blue }" class="mr-0-5" icon="info-square-fill"/>
            <b>Destination IP:</b>
            {{ selectedTraffic.ip ? selectedTraffic.ip : 'N/A' }}
          </span>
          <span>
            <b-icon variant="success" class="mr-0-5" icon="tag-fill"/>
            <b>Domain Name:</b>
            {{ (selectedTraffic.domains || []).join(', ') || 'N/A' }}
          </span>
        </div>
      </b-card>
      <h4 class="mb-1" v-else>No Traffic Selected</h4>
    </b-row>
    <b-row v-if="hasTrafficSelection" class="ml-0-5 my-1">
      <b-col>
        <div v-if="hasData">
          <b-table
            class="table-with-actions-min-height px-2"
            responsive
            striped
            outlined
            :items="trafficFilter"
            :fields="computedTableFields"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
          />
          <b-pagination
            v-model="currentPage"
            :total-rows="paginationTotalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-2 mx-1"
          />
        </div>
        <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
          {{ $t("No Data Available") }}
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedTraffic: null,
      trafficDetails: [],
      loaded: false,
      currentPage: 1,
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        { key: 'deviceName', label: 'Device', sortable: true },
        { key: 'processName', label: 'Process', sortable: true },
        { key: 'totalConnectionCount', label: 'Total connections', sortable: true },
      ],
      iconColors: {
        blue: colorPalette.teal,
        purple: colorPalette.purple,
      },
    };
  },
  computed: {
    hasTrafficSelection() {
      return this.selectedTraffic !== null && this.selectedTraffic !== undefined;
    },
    hasData() {
      return this.loaded && this.trafficDetails && this.trafficDetails.length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.trafficDetails.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    trafficFilter() {
      return this.trafficDetails;
    },
  },
  watch: {
    timeRange() {
      this.selectedTraffic = null;
    },
  },
  created() {
    SecurityEventBus.$on('update-selected-traffic', (curTraffic) => {
      this.selectedTraffic = curTraffic;
      this.httpGet();
    });
  },
  methods: {
    httpGet() {
      const detailEndpoint = `/security/endpoint/${this.selectedTraffic.ip}/trafficdetails.json`;

      this.loaded = false;
      this.$http
        .get(detailEndpoint, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.trafficDetails = response.data; })
        .finally(() => { this.loaded = true; });
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.header-card {
  width: 100%;
}
.header-card>.card-body {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.details-row {
  gap: 5rem;
}
</style>
